import { defineStore } from 'pinia';

export const useCardStore = defineStore('card', {
  state: () => ({
    cards: [],
    suggestedData: {},
  }),
  actions: {
    async submitCard(cardData) {
      // Logic to submit card data to the backend
      this.cards.push(cardData);
    },
    setSuggestedData(nextCardType, suggestedData) {
      this.suggestedData[nextCardType] = suggestedData;
    },
  },
});
